import './PeriscopeView.scss';

import { BulkAddSelectionContextWidget } from './bulk-add/BulkAddSelectionContextWidget';
import { PeriscopeSummaryList } from './PeriscopeSummaryList';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useLocation } from 'react-router-dom';
import { ViewArea } from '@ui/general';

import { useOnMount, usePeriscopeActions, usePeriscopeCount, usePeriscopeReset } from '@hooks';

const periscopeMaxWidth = 910;
const periscopeMinWidth = 300;

function getPeriscopeFromPath(path: string) {
	const pathParts = path.split('/');
	const [ , , type, id, displayName ] = pathParts;

	return {
		id: Number(id),
		name: displayName ? decodeURIComponent(displayName) : '',
		type: type as SonarObjectType
	};
}

export interface PeriscopeViewProps {
	noPadding?: boolean;
	skipOnMount?: boolean;
}

export const PeriscopeView: React.FC<PeriscopeViewProps> = ({ noPadding, skipOnMount }) => {
	const location = useLocation();
	const { openPeriscope } = usePeriscopeActions();
	const periscopeCount = usePeriscopeCount();
	const resetPeriscopes = usePeriscopeReset();

	useOnMount(() => {
		if (skipOnMount) {
			resetPeriscopes();

			return;
		}

		if (periscopeCount === 0) {
			openPeriscope({
				...getPeriscopeFromPath(location.pathname)
			});
		}

		return () => {
			resetPeriscopes();
		};
	});

	const periscopeWidth = {
		maxWidth: periscopeCount * periscopeMaxWidth,
		minWidth: periscopeCount * periscopeMinWidth
	};

	return (
		<ViewArea
			className='periscope-view'
			fullHeight
			fullWidth
			noPadding={ noPadding }>
			<div
				className='periscope-list'
				style={ periscopeWidth }>
				<BulkAddSelectionContextWidget />
				<div className='periscope-container'>
					<PeriscopeSummaryList />
				</div>
			</div>
		</ViewArea>
	);
};
